import { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { EosContextView } from '../../../../models/payroll';
import { getApiErrorMessage } from '../../../../utils/apiErrors';
import { GetEosContext } from '../../../../api/Payroll/payroll';

export function useEosContext(userId: string) {
  const { t } = useTranslation();
  const [context, setContext] = useState<EosContextView | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refetch = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    setError(null);
    try {
      const result = await GetEosContext(userId);
      if (result.errors && result.errors.length > 0) {
        setError(getApiErrorMessage(result, t, t('Failed to load EOS context')));
        setContext(null);
      } else {
        setContext(result.payload);
      }
    } catch (err: unknown) {
      // CO-569: the interceptor rejects with the parsed `Result` body (a plain object), so the
      // `instanceof Error` arm never ran and every refusal read "Failed to load EOS context".
      setError(getApiErrorMessage(err, t, t('Failed to load EOS context')));
      setContext(null);
    } finally {
      setLoading(false);
    }
  }, [userId, t]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { context, loading, error, refetch };
}
